module.exports = __webpack_public_path__ + "img/industry-image.d4b718e4.jpg";